export const DASHBOARD = 'dashboard';
export const WEEK = 'week';
export const CALENDAR = 'calendar';
export const DAY = 'day';

export const CALENDAR_DASHBOARD_VIEW_SEGMENTED = [
  {
    id: 1,
    value: CALENDAR,
    label: 'Calendar',
  },
  {
    id: 2,
    value: DASHBOARD,
    label: 'Dashboard',
  },
];

export const DAILY_WEEKLY_VIEW_SEGMENTED = [
  {
    value: 0,
    label: 'Day',
  },
  {
    value: 1,
    label: 'Week',
  },
];

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// keep this in line with Date.getDay() = 0 for Sunday,
export const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const weekdayOnly = [
  { day: 'monday' },
  { day: 'tuesday' },
  { day: 'wednesday' },
  { day: 'thursday' },
  { day: 'friday' },
];

export const recurrenceOptions = [
  { label: 'Daily' },
  { label: 'Weekly' },
  { label: 'Monthly' },
  { label: 'Yearly' },
  { label: 'Every weekday (Monday to Friday)' },
  { label: 'Custom' },
];

export const getRecurrenceOptions = (scheduledDate: Date) => {
  const formattedDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayOfWeek = scheduledDate.getDay();
  const dayOfMonth = scheduledDate.getDate();
  const monthOfYear = scheduledDate.toLocaleString('en-US', { month: 'long' });

  return [
    { label: 'Daily' },
    {
      label: `Weekly on ${formattedDays[dayOfWeek]}`,
    },
    {
      label: `Monthly on ${dayOfMonth}`,
    },
    {
      label: `Yearly on ${monthOfYear} ${dayOfMonth}`,
    },
    { label: 'Every weekday (Monday to Friday)' },
    { label: 'Custom' },
  ];
};
